export default __webpack_public_path__ + "static/media/path_12.b253d6fa.png";